/* eslint-disable jsx-a11y/label-has-associated-control */
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import get from 'lodash/get';
import pick from 'lodash/pick';
import flatten from 'lodash/flatten';
import queryString from 'query-string';
import mapValues from 'lodash/mapValues';
import FormField from './FormField';
import { withAppContext } from '../Context';
import { appDataProps } from '../utils/propTypes';

export const formFields = [
  {
    label: 'Nom complet',
    children: [
      {
        type: 'input',
        icon: 'user',
        fieldType: 'text',
        name: 'firstName',
        placeholder: 'Prénom',
        required: true,
      },
      {
        type: 'input',
        icon: 'user',
        fieldType: 'text',
        name: 'lastName',
        placeholder: 'Nom',
        required: true,
      },
    ],
  },
  {
    label: 'Email',
    children: [
      {
        type: 'input',
        icon: 'envelope',
        fieldType: 'email',
        name: 'email',
        placeholder: 'Email',
        required: true,
      },
    ],
  },
  {
    label: 'Sujet',
    children: [
      {
        type: 'input',
        icon: 'edit',
        fieldType: 'text',
        name: 'subject',
        placeholder: 'Sujet',
        required: true,
      },
    ],
  },
  {
    label: 'Message',
    children: [{ type: 'textarea', name: 'message', placeholder: 'Message', required: true }],
  },
  { children: [{ type: 'button', name: 'Envoyer' }] },
];

class ContactForm extends PureComponent {
  constructor(props) {
    super(props);
    const fieldNames = flatten(
      props.fields.map((field) => field.children.map((f) => f.name).filter((v) => v)),
    );
    // TODO: FIX DATA
    const defaultData = pick(get(props.data, 'user'), fieldNames) || {};
    this.state = {
      validate: false,
      state: 'IDLE',
      data: defaultData,
      disabledFields: mapValues(defaultData, (v) => !!v),
    };
  }

  isValid = () => {
    const { data } = this.state;
    const { fields } = this.props;
    // Find error ?
    return !fields.find((line) => line.children.find((f) => f.required && !data[f.name]));
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    // Check if everything is valid
    if (this.isValid()) {
      const { data } = this.state;
      this.setState({ state: 'SENDING' });
      try {
        const res = await fetch('', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
        });
        this.setState({ state: res.ok ? 'DONE' : 'ERROR' });
      } catch (error) {
        // Try to send without post...
        const res = await fetch(`./send-form?${queryString.stringify(data)}`);
        this.setState({ state: res.ok ? 'DONE' : 'ERROR' });
      }
    } else {
      this.setState({ validate: true });
    }
  };

  handleChange = (name, value) => {
    const { data } = this.state;
    this.setState({
      data: { ...data, [name]: value },
    });
  };

  render() {
    const { fields, strings = {} } = this.props;
    const {
      validateLabel = 'Merci pour votre retour, nous reviendrons vers vous rapidement.',
      errorLabel = 'Une erreur est survenue, merci de réessayer.',
      requiredLabel = 'Ce champ est obligatoire',
    } = strings;
    const { validate, data, state, disabledFields } = this.state;
    if (state === 'DONE') {
      return <div style={{ textAlign: 'center' }}>{validateLabel}</div>;
    }
    return (
      <form onSubmit={this.handleSubmit}>
        {fields.map((field, index) => {
          const { label, children } = field;
          return (
            // eslint-disable-next-line react/no-array-index-key
            <div key={index} className="field is-horizontal">
              <div className="field-label is-normal">
                <label className="label">{label}</label>
              </div>
              <div className="field-body">
                {children.map((child, idx) => (
                  <FormField
                    // eslint-disable-next-line react/no-array-index-key
                    key={idx}
                    {...child}
                    value={data[child.name]}
                    validate={validate}
                    state={state}
                    disabled={child.disabled || disabledFields[child.name] || false}
                    onChange={this.handleChange}
                    onSubmit={this.handleSubmit}
                    requiredLabel={requiredLabel}
                  />
                ))}
              </div>
            </div>
          );
        })}
        {state === 'ERROR' && (
          <div className="field is-horizontal">
            <div className="field-label is-normal" />
            <div className="field-body">
              <div className="help is-danger">{errorLabel}</div>
            </div>
          </div>
        )}
      </form>
    );
  }
}

ContactForm.defaultProps = {
  fields: formFields,
  strings: {},
};

ContactForm.propTypes = {
  data: appDataProps.isRequired,
  fields: PropTypes.array,
  strings: PropTypes.object,
};

export default withAppContext(ContactForm);
